if (!customElements.get('mz-cap-journey')) {
  customElements.define('mz-cap-journey', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.preference = matchMedia('(prefers-reduced-motion: reduce)');
      this.userEnabled = true;
      this.overrideReduced = false;
      this.toggle = this.querySelector('[data-flow-toggle]');
      this.note = this.querySelector('[data-flow-reduced]');
      this.items = [...this.querySelectorAll('[data-flow-chapter]')].map(element => ({
        element,
        visual: element.querySelector('[data-flow-visual]'),
        object: element.querySelector('[data-flow-object]'),
        visible: true
      }));
      this.frame = 0;
      this.update = () => {
        if (!this.motionEnabled || this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.render(); });
      };
      this.configure = () => {
        this.motionEnabled = this.userEnabled && (!this.preference.matches || this.overrideReduced);
        this.classList.toggle('is-flow-enhanced', this.motionEnabled);
        this.classList.toggle('is-motion-opt-in', this.motionEnabled && this.overrideReduced);
        this.dataset.motionState = this.motionEnabled ? 'on' : this.preference.matches ? 'reduced' : 'off';
        if (this.toggle) {
          this.toggle.hidden = false;
          this.toggle.setAttribute('aria-pressed', String(this.motionEnabled));
          this.toggle.setAttribute('aria-label', this.motionEnabled ? this.toggle.dataset.disable : this.toggle.dataset.enable);
        }
        if (this.note) this.note.hidden = !this.preference.matches || this.overrideReduced;
        if (this.motionEnabled) this.render();
        else this.items.forEach(item => { item.object.style.transform = ''; });
      };
      this.toggleHandler = () => {
        if (this.motionEnabled) this.userEnabled = false;
        else {
          this.userEnabled = true;
          this.overrideReduced = this.preference.matches;
        }
        this.configure();
      };
      this.toggle?.addEventListener('click', this.toggleHandler);
      this.preferenceHandler = () => { this.overrideReduced = false; this.configure(); };
      addEventListener('scroll', this.update, { passive: true });
      addEventListener('resize', this.update, { passive: true });
      if (this.preference.addEventListener) this.preference.addEventListener('change', this.preferenceHandler);
      else this.preference.addListener(this.preferenceHandler);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            const item = this.items.find(item => item.element === entry.target);
            if (item) item.visible = entry.isIntersecting;
          });
          this.update();
        }, { rootMargin: '260px 0px' });
        this.items.forEach(item => this.observer.observe(item.element));
      }
      this.configure();
    }
    render() {
      if (!this.motionEnabled) return;
      const height = innerHeight;
      const maxLift = innerWidth < 750 ? 190 : 260;
      this.items.forEach(item => {
        if (!item.visible) return;
        const rect = item.visual.getBoundingClientRect();
        const start = height * 0.98;
        const end = height * 0.05 - rect.height * 0.25;
        const progress = Math.max(0, Math.min(1, (start - rect.top) / (start - end)));
        const lift = maxLift * (0.6 - progress);
        const scale = 0.85 + 0.25 * progress;
        item.object.style.transform = `translate3d(0,${lift.toFixed(2)}px,0) scale(${scale.toFixed(4)})`;
        item.element.dataset.flowProgress = progress.toFixed(3);
        item.element.dataset.flowArrived = String(progress === 1);
      });
    }
    disconnectedCallback() {
      removeEventListener('scroll', this.update);
      removeEventListener('resize', this.update);
      this.toggle?.removeEventListener('click', this.toggleHandler);
      if (this.preference?.removeEventListener) this.preference.removeEventListener('change', this.preferenceHandler);
      else this.preference?.removeListener(this.preferenceHandler);
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.ready = false;
    }
  });
}
